var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingBlock container text-center"},[_c('loadingSVG',{staticClass:"w-full"}),_c('span',{staticClass:"text-blue font-bold text-xl mt-8"},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.$t('loading'))+"...")])])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }